import common from '@/store/common/mutations';
import * as types from './mutation-types';

export default {
	...common,
	[types.SEARCH_PARAM]: (state, payload) => {
		state.searchParams[payload.key] = payload.value;
	},
	[types.DEFAULT_ASSIGN]: (state, { key , value }) => {
		state[key] = value;
	},
	[types.GROUPS]: (state, { key , value }) => {
		state.GROUPS[key] = value;
	},
	[types.SELECTED_ROW]: (state, { key, value }) => {
		state.selectedRow[key] = value;
	}
};